import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbHighlight, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  merge,
  Observable,
  of,
  Subject,
  switchMap,
} from 'rxjs';
import { map } from 'rxjs/operators';
import { AdminClusterService, Cluster } from '@shared/services/admin-cluster.service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-cluster-selector',
  templateUrl: './admin-cluster-selector.component.html',
  styleUrl: './admin-cluster-selector.component.scss',
  imports: [NgbTypeahead, FormsModule, NgbHighlight],
})
export class AdminClusterSelectorComponent {
  @Input() model: ClusterName;
  @Input() filters: { [k: string]: any };
  @Output() modelChange = new EventEmitter<string>();

  @ViewChild('instance', { static: true }) instance: NgbTypeahead;

  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  constructor(private clusterService: AdminClusterService) {}

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      switchMap((term) => {
        return term.length < 2
          ? of([] as Cluster[])
          : this.clusterService.getPage({ ...this.filters, filter: term }).pipe(
              catchError((error) => {
                console.error(error);
                return of({ content: [] as Cluster[] });
              }), // empty list on error
              map((page) => page.content),
            );
      }),
    );
  };

  formatter = (cluster: ClusterName) => cluster.name;
}

export interface ClusterName {
  name: string;
}
